/* Evora Haven theme — one small, dependency-free script. */
(function () {
  'use strict';

  var theme = window.theme || {};
  var PROTECTION_OPTOUT_KEY = 'evora_protection_optout';

  /* ---------------------------------------------------------------- utils */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function store(key, val) {
    try { if (val === undefined) return window.localStorage.getItem(key); if (val === null) window.localStorage.removeItem(key); else window.localStorage.setItem(key, val); } catch (e) { return null; }
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Math.round(Number(cents) || 0);
    format = format || theme.moneyFormat || '${{amount}}';
    function withDelimiters(number, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      var n = (number / 100).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }
  theme.formatMoney = formatMoney;

  /* ------------------------------------------------------- announcement */
  $$('[data-announcement]').forEach(function (bar) {
    var items = $$('.announcement__item', bar);
    if (items.length < 2) return;
    var i = 0;
    var speed = (parseInt(bar.getAttribute('data-speed'), 10) || 5) * 1000;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, speed);
  });

  /* -------------------------------------------------------- mobile menu */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-open]')) { document.documentElement.classList.add('menu-open'); var c = $('[data-menu-close]'); if (c) c.focus(); }
    if (e.target.closest('[data-menu-close]')) document.documentElement.classList.remove('menu-open');
  });

  /* ----------------------------------------------------------- lightbox */
  var Lightbox = (function () {
    var el, stage, mediaWrap, reviewEl, counter, items = [], index = 0, lastFocus = null, touchX = null;

    function init() {
      el = $('[data-lightbox]');
      if (!el) return false;
      mediaWrap = $('.lightbox__media', el);
      reviewEl = $('.lightbox__review', el);
      counter = $('.lightbox__counter', el);
      stage = $('.lightbox__stage', el);
      el.addEventListener('click', function (e) {
        if (e.target.closest('[data-lightbox-close]') || e.target === stage) close();
        if (e.target.closest('[data-lightbox-prev]')) go(-1);
        if (e.target.closest('[data-lightbox-next]')) go(1);
      });
      stage.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (touchX === null) return;
        var dx = e.changedTouches[0].clientX - touchX;
        if (Math.abs(dx) > 45) go(dx < 0 ? 1 : -1);
        touchX = null;
      });
      document.addEventListener('keydown', function (e) {
        if (!el.classList.contains('is-open')) return;
        if (e.key === 'Escape') close();
        if (e.key === 'ArrowRight') go(1);
        if (e.key === 'ArrowLeft') go(-1);
        if (e.key === 'Tab') trapFocus(e, el);
      });
      return true;
    }

    function stars(n) {
      var tpl = $('#star-template');
      var out = '';
      for (var i = 0; i < 5; i++) out += tpl ? tpl.innerHTML.replace('data-fill=""', i < Math.round(n) ? 'fill="currentColor"' : 'fill="none"') : '';
      return '<span class="stars" aria-label="' + n + ' out of 5 stars">' + out + '</span>';
    }

    function escapeHtml(s) { var d = document.createElement('div'); d.textContent = s || ''; return d.innerHTML; }

    function render() {
      var item = items[index];
      if (!item) return;
      var html = '';
      if (item.type === 'image') html = '<img src="' + item.src + '" alt="' + escapeHtml(item.alt) + '">';
      else if (item.type === 'video') html = '<video src="' + item.src + '" controls playsinline autoplay muted loop></video>';
      else if (item.type === 'html') html = item.html;
      else html = '<div class="placeholder"><span class="placeholder__type">' + escapeHtml(item.kind || 'IMAGE PLACEHOLDER') + '</span><span class="placeholder__label">' + escapeHtml(item.label) + '</span></div>';
      mediaWrap.innerHTML = html;
      counter.textContent = (index + 1) + ' / ' + items.length;
      var multi = items.length > 1;
      $$('.lightbox__nav', el).forEach(function (b) { b.hidden = !multi; });
      if (item.review) {
        el.classList.add('lightbox--review');
        reviewEl.hidden = false;
        var r = item.review;
        reviewEl.innerHTML =
          '<div>' + stars(r.rating || 5) + '</div>' +
          '<div class="lightbox__review-name">' + escapeHtml(r.name) + (r.verified ? ' <span class="verified">' + ($('#verified-template') ? $('#verified-template').innerHTML : '') + 'Verified purchase</span>' : '') + '</div>' +
          (r.date ? '<div class="text-soft">' + escapeHtml(r.date) + '</div>' : '') +
          (r.title ? '<p class="review__title">' + escapeHtml(r.title) + '</p>' : '') +
          '<p class="lightbox__review-text">' + escapeHtml(r.text) + '</p>';
      } else {
        el.classList.remove('lightbox--review');
        reviewEl.hidden = true;
        reviewEl.innerHTML = '';
      }
    }

    function go(dir) {
      if (!items.length) return;
      index = (index + dir + items.length) % items.length; /* loops both ways */
      render();
    }

    function open(list, start) {
      if (!el && !init()) return;
      items = list || [];
      index = start || 0;
      lastFocus = document.activeElement;
      render();
      el.classList.add('is-open');
      document.documentElement.classList.add('lightbox-open');
      var c = $('.lightbox__close', el); if (c) c.focus();
    }

    function close() {
      el.classList.remove('is-open');
      document.documentElement.classList.remove('lightbox-open');
      mediaWrap.innerHTML = '';
      if (lastFocus) lastFocus.focus();
    }

    return { open: open, close: close };
  })();
  theme.Lightbox = Lightbox;

  function trapFocus(e, container) {
    var f = $$('a[href], button:not([disabled]):not([hidden]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])', container)
      .filter(function (n) { return n.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function readJSON(el) {
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  /* ------------------------------------------------------------ gallery */
  function Gallery(root) {
    var track = $('.gallery__track', root);
    var slides = $$('.gallery__slide', root);
    var thumbs = $$('.gallery__thumb', root);
    var counter = $('.gallery__counter', root);
    var current = 0;
    if (!track || !slides.length) return;

    function goTo(i, smooth) {
      current = (i + slides.length) % slides.length; /* loop */
      track.scrollTo({ left: slides[current].offsetLeft - track.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      sync();
    }
    function sync() {
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === current ? 'true' : 'false'); });
      if (counter) counter.textContent = (current + 1) + ' / ' + slides.length;
      var activeThumb = thumbs[current];
      if (activeThumb && activeThumb.parentNode.scrollWidth > activeThumb.parentNode.clientWidth) {
        activeThumb.parentNode.scrollTo({ left: activeThumb.offsetLeft - 40, behavior: 'smooth' });
      }
      slides.forEach(function (s, n) {
        var v = $('video', s);
        if (v && n !== current && !v.paused && !v.autoplay) v.pause();
      });
    }
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== current && i >= 0 && i < slides.length) { current = i; sync(); }
      });
    }, { passive: true });

    var prev = $('[data-gallery-prev]', root), next = $('[data-gallery-next]', root);
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { goTo(n); }); });
    root.addEventListener('keydown', function (e) {
      if (e.target.closest('input, textarea')) return;
      if (e.key === 'ArrowRight') { goTo(current + 1); }
      if (e.key === 'ArrowLeft') { goTo(current - 1); }
    });

    var data = readJSON($('[data-gallery-json]', root)) || [];
    $$('[data-gallery-zoom]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var i = parseInt(btn.getAttribute('data-index'), 10) || 0;
        Lightbox.open(data, i);
      });
    });
    window.addEventListener('resize', function () { goTo(current, false); });
    sync();
  }
  $$('[data-gallery]').forEach(Gallery);

  /* --------------------------------------------------- video play toggle */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-video-toggle]');
    if (!b) return;
    var v = $('video', b.parentNode);
    if (!v) return;
    if (v.paused) { v.play(); b.setAttribute('aria-label', 'Pause video'); b.classList.add('is-playing'); }
    else { v.pause(); b.setAttribute('aria-label', 'Play video'); b.classList.remove('is-playing'); }
  });

  /* ------------------------------------------------------------ reviews */
  $$('[data-reviews]').forEach(function (section) {
    var data = readJSON($('[data-reviews-json]', section)) || [];
    section.addEventListener('click', function (e) {
      var p = e.target.closest('[data-review-photo]');
      if (p) { Lightbox.open(data, parseInt(p.getAttribute('data-index'), 10) || 0); return; }
      var more = e.target.closest('[data-reviews-more]');
      if (more) {
        var step = parseInt(more.getAttribute('data-step'), 10) || 4;
        var hidden = $$('.review.is-hidden', section).slice(0, step);
        hidden.forEach(function (r) { r.classList.remove('is-hidden'); });
        if (!$$('.review.is-hidden', section).length) more.parentNode.hidden = true;
      }
    });
  });

  /* ---------------------------------------------------------------- cart */
  var Cart = (function () {
    var busy = false;

    function drawer() { return $('[data-cart-drawer]'); }
    function sectionId() { var d = drawer(); return d ? d.getAttribute('data-section-id') : 'cart-drawer'; }

    function open() {
      var d = drawer();
      if (!d) { window.location.href = (theme.routes && theme.routes.cart || '/cart').replace('.js', ''); return; }
      Cart._lastFocus = document.activeElement;
      document.documentElement.classList.add('cart-open');
      d.setAttribute('aria-hidden', 'false');
      setTimeout(function () { var c = $('[data-cart-close]', d); if (c) c.focus(); }, 60);
    }
    function close() {
      var d = drawer();
      document.documentElement.classList.remove('cart-open');
      if (d) d.setAttribute('aria-hidden', 'true');
      if (Cart._lastFocus && Cart._lastFocus.focus) Cart._lastFocus.focus();
    }

    function renderSection(html) {
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = $('[data-cart-drawer]', doc);
      var d = drawer();
      if (fresh && d) {
        var scroll = $('.cart-drawer__body', d) ? $('.cart-drawer__body', d).scrollTop : 0;
        d.innerHTML = fresh.innerHTML;
        ['data-item-count', 'data-protection-variant', 'data-protection-default', 'data-protection-in-cart', 'data-product-lines'].forEach(function (a) {
          if (fresh.hasAttribute(a)) d.setAttribute(a, fresh.getAttribute(a)); else d.removeAttribute(a);
        });
        var body = $('.cart-drawer__body', d); if (body) body.scrollTop = scroll;
        if (parseInt(fresh.getAttribute('data-item-count'), 10) > 0) {
          var inCart = fresh.getAttribute('data-protection-in-cart') === 'true';
          $$('[data-buybox-protection]').forEach(function (cb) { cb.checked = inCart; });
        }
        updateCount(fresh.getAttribute('data-item-count'));
      }
    }

    function updateCount(n) {
      $$('[data-cart-count]').forEach(function (c) { c.textContent = n; c.setAttribute('data-count', n); });
    }

    function request(url, body) {
      body.sections = sectionId();
      body.sections_url = window.location.pathname;
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        return r.json().then(function (json) {
          if (!r.ok || json.status) { var err = new Error(json.description || json.message || 'Something went wrong. Please try again.'); err.json = json; throw err; }
          return json;
        });
      });
    }

    function setBusy(on) { var d = drawer(); if (d) d.classList.toggle('is-busy', on); busy = on; }

    function protectionVariant() { var d = drawer(); return d ? parseInt(d.getAttribute('data-protection-variant'), 10) || null : null; }

    function add(items, protectionHandled) {
      var pv = protectionVariant();
      var d = drawer();
      if (!protectionHandled && pv && d && d.getAttribute('data-protection-default') === 'true' && d.getAttribute('data-protection-in-cart') !== 'true' && !store(PROTECTION_OPTOUT_KEY)) {
        items = items.concat([{ id: pv, quantity: 1 }]);
      }
      return request(theme.routes.cartAdd, { items: items }).then(function (res) {
        renderSection(res.sections && res.sections[sectionId()]);
        open();
        return res;
      });
    }

    function change(key, qty) {
      if (busy) return Promise.resolve();
      setBusy(true);
      return request(theme.routes.cartChange, { id: key, quantity: qty }).then(function (res) {
        renderSection(res.sections && res.sections[sectionId()]);
        return cleanupProtection(res);
      }).catch(function (err) { alert(err.message); }).then(function () { setBusy(false); });
    }

    /* If only the protection item is left, remove it so nobody pays for protecting nothing. */
    function cleanupProtection(cart) {
      var pv = protectionVariant();
      if (!pv || !cart || !cart.items) return;
      var others = cart.items.filter(function (i) { return i.variant_id !== pv; });
      var prot = cart.items.filter(function (i) { return i.variant_id === pv; });
      if (!others.length && prot.length) {
        return request(theme.routes.cartChange, { id: prot[0].key, quantity: 0 }).then(function (res) { renderSection(res.sections && res.sections[sectionId()]); });
      }
      if (prot.length && prot[0].quantity > 1) {
        return request(theme.routes.cartChange, { id: prot[0].key, quantity: 1 }).then(function (res) { renderSection(res.sections && res.sections[sectionId()]); });
      }
    }

    function toggleProtection(on) {
      var pv = protectionVariant();
      if (!pv) return;
      setBusy(true);
      store(PROTECTION_OPTOUT_KEY, on ? null : '1');
      var p = on
        ? request(theme.routes.cartAdd, { items: [{ id: pv, quantity: 1 }] })
        : request(theme.routes.cartChange, { id: String(pv), quantity: 0 });
      return p.then(function (res) { renderSection(res.sections && res.sections[sectionId()]); })
        .catch(function (err) { alert(err.message); })
        .then(function () { setBusy(false); });
    }

    /* Drawer interactions (event delegation, survives re-renders) */
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-open]')) { e.preventDefault(); open(); return; }
      if (e.target.closest('[data-cart-close]') || e.target.classList.contains('cart-drawer__overlay')) { close(); return; }
      var rm = e.target.closest('[data-cart-remove]');
      if (rm) { change(rm.getAttribute('data-key'), 0); return; }
      var step = e.target.closest('[data-cart-qty-step]');
      if (step) {
        var input = $('input', step.parentNode);
        var v = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-cart-qty-step'), 10));
        input.value = v;
        change(input.getAttribute('data-key'), v);
        return;
      }
      var up = e.target.closest('[data-upsell-add]');
      if (up) {
        up.classList.add('is-loading');
        add([{ id: parseInt(up.getAttribute('data-variant-id'), 10), quantity: 1 }]).catch(function (err) { alert(err.message); }).then(function () { up.classList.remove('is-loading'); });
      }
    });
    document.addEventListener('change', function (e) {
      if (e.target.matches('[data-protection-toggle]')) toggleProtection(e.target.checked);
      if (e.target.matches('[data-cart-qty-input]')) change(e.target.getAttribute('data-key'), Math.max(0, parseInt(e.target.value, 10) || 0));
    });
    document.addEventListener('keydown', function (e) {
      if (!document.documentElement.classList.contains('cart-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'Tab') { var d = drawer(); if (d) trapFocus(e, d); }
    });

    return { add: add, open: open, close: close, change: change };
  })();
  theme.Cart = Cart;

  /* ------------------------------------------------------ product buy box */
  function BuyBox(section) {
    var data = readJSON($('[data-product-json]', section));
    if (!data) return;
    var state = { variant: null, offer: 0, qty: 1 };
    var form = $('[data-product-form]', section);
    var errorEl = $('[data-buy-error]', section);
    var sticky = $('[data-sticky-atc]', section);

    state.variant = data.variants.filter(function (v) { return v.id === data.selectedVariantId; })[0] || data.variants[0];
    var checkedOffer = $('input[name="offer"]:checked', section);
    state.offer = checkedOffer ? parseInt(checkedOffer.value, 10) : 0;

    function currentOffer() { return data.offers[state.offer] || null; }
    function variantById(id) { return data.variants.filter(function (v) { return v.id === id; })[0] || null; }
    /* A bundle linked to its own variant (e.g. "3") uses that variant's price + compare-at */
    function offerVariant(o) { return (o && o.variantId) ? variantById(o.variantId) : null; }
    function syncVariantToOffer() { var lv = offerVariant(currentOffer()); if (lv) state.variant = lv; }

    function totals(variant, offer, qty) {
      var lv = offerVariant(offer);
      if (lv) {
        var bars = offer.quantity || 1;
        var lp = lv.price * qty;
        var lc = (lv.compare_at_price && lv.compare_at_price > lv.price) ? lv.compare_at_price * qty : 0;
        /* qty = cart units of the bundle variant; perUnit = price per bar */
        return { price: lp, compare: lc, qty: qty, perUnit: Math.round(lv.price / bars), linked: true };
      }
      var unit = variant.price;
      var q = (offer ? offer.quantity : 1) * qty;
      var full = unit * q;
      var discount = offer ? (offer.discount || 0) : 0;
      var price = Math.round(full * (1 - discount / 100));
      var compare = 0;
      if (variant.compare_at_price && variant.compare_at_price > unit) compare = variant.compare_at_price * q;
      else if (price < full) compare = full;
      return { price: price, compare: compare > price ? compare : 0, qty: q, perUnit: Math.round(price / q) };
    }

    function offerTexts(o, v) {
      var ot = totals(v, o, 1);
      var pct = ot.compare ? Math.round((1 - ot.price / ot.compare) * 100) : 0;
      if (ot.linked) {
        return {
          price: formatMoney(ot.price),
          compare: ot.compare ? formatMoney(ot.compare) : '',
          unit: (o.quantity > 1 && o.unitTemplate) ? o.unitTemplate.replace('[amount]', formatMoney(ot.perUnit)) : '',
          save: pct > 0 ? 'Save ' + pct + '%' : '',
          fixed: false
        };
      }
      return {
        price: o.priceText || formatMoney(ot.price),
        compare: o.compareText || (ot.compare ? formatMoney(ot.compare) : ''),
        unit: o.unitText || (o.quantity > 1 && o.unitTemplate ? o.unitTemplate.replace('[amount]', formatMoney(ot.perUnit)) : ''),
        save: o.saveText || (pct > 0 ? 'Save ' + pct + '%' : ''),
        fixed: !!o.priceText
      };
    }

    function render() {
      var v = state.variant;
      var off = currentOffer();
      var t = totals(v, off, state.qty);
      var tx = off ? offerTexts(off, v) : null;
      var priceLabel = (tx && tx.fixed && state.qty === 1) ? tx.price : formatMoney(t.price);
      $$('[data-price-current]', section).forEach(function (el) { el.textContent = priceLabel; });
      /* offer cards (prices recalculated only when not using fixed placeholder text) */
      data.offers.forEach(function (o, i) {
        var card = $('[data-offer-index="' + i + '"]', section);
        if (!card) return;
        var otx = offerTexts(o, v);
        var p = $('[data-offer-price]', card); if (p) p.textContent = otx.price;
        var c = $('[data-offer-compare]', card); if (c) { c.textContent = otx.compare; c.hidden = !otx.compare; }
        var u = $('[data-offer-unit]', card); if (u && otx.unit) u.textContent = otx.unit;
        card.classList.toggle('is-selected', i === state.offer);
      });
      var available = v.available;
      $$('[data-atc]', document).forEach(function (btn) {
        if (btn.closest('[data-product-section]') && btn.closest('[data-product-section]') !== section) return;
        var label = $('[data-atc-label]', btn);
        var price = $('[data-atc-price]', btn);
        if (label) label.textContent = available ? (btn.getAttribute('data-label') || 'Add to cart') : (btn.getAttribute('data-soldout') || 'Sold out');
        if (price) price.textContent = available ? priceLabel : '';
        $$('.btn__sep', btn).forEach(function (s) { s.hidden = !available; });
        btn.disabled = !available;
      });
      if (sticky) {
        var so = $('[data-sticky-offer]', sticky);
        var sp = $('[data-sticky-price]', sticky);
        if (so) so.textContent = off ? off.title + (state.qty > 1 ? ' × ' + state.qty : '') + (tx.save ? ' · ' + tx.save : '') + ' ·' : 'Qty ' + t.qty + ' ·';
        if (sp) sp.textContent = priceLabel;
      }
      var idInput = $('input[name="id"]', form); if (idInput) idInput.value = v.id;
      var qtyInput = $('input[name="quantity"]', form); if (qtyInput) qtyInput.value = t.qty;
    }

    /* events */
    section.addEventListener('change', function (e) {
      if (e.target.name === 'offer') {
        state.offer = parseInt(e.target.value, 10) || 0;
        syncVariantToOffer();
        if (offerVariant(currentOffer()) && history.replaceState && data.url) { try { history.replaceState({}, '', data.url + '?variant=' + state.variant.id); } catch (err) {} }
        render();
      }
      if (e.target.matches('[data-option-input]')) {
        var chosen = $$('[data-option-group]', section).map(function (g) { var c = $('input:checked', g); return c ? c.value : null; });
        var match = data.variants.filter(function (v) { return v.options.every(function (o, i) { return o === chosen[i]; }); })[0];
        if (match) {
          state.variant = match;
          if (match.featured_media_index !== null && match.featured_media_index !== undefined) {
            var thumb = $$('.gallery__thumb', section)[match.featured_media_index]; if (thumb) thumb.click();
          }
          if (history.replaceState && data.url) history.replaceState({}, '', data.url + '?variant=' + match.id);
        }
        render();
      }
      if (e.target.matches('[data-qty-input]')) { state.qty = Math.max(1, parseInt(e.target.value, 10) || 1); e.target.value = state.qty; render(); }
    });
    section.addEventListener('click', function (e) {
      var s = e.target.closest('[data-qty-step]');
      if (s) {
        var input = $('[data-qty-input]', section);
        state.qty = Math.max(1, state.qty + parseInt(s.getAttribute('data-qty-step'), 10));
        if (input) input.value = state.qty;
        render();
      }
    });

    function addToCart(btn) {
      if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
      var t = totals(state.variant, currentOffer(), state.qty);
      if (btn) btn.classList.add('is-loading');
      var item = { id: state.variant.id, quantity: t.qty };
      var off = currentOffer();
      if (off && off.quantity > 1 && !off.variantId) item.properties = { _bundle: off.title }; /* linked bundles already show as their variant, e.g. "3 bars" */
      var items = [item];
      var pbox = $('[data-buybox-protection]', section);
      if (pbox && pbox.checked) {
        var d = $('[data-cart-drawer]');
        if (!d || d.getAttribute('data-protection-in-cart') !== 'true') items.push({ id: parseInt(pbox.getAttribute('data-variant-id'), 10), quantity: 1 });
      }
      return Cart.add(items, !!pbox).catch(function (err) {
        if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
        else alert(err.message);
      }).then(function () { if (btn) btn.classList.remove('is-loading'); });
    }

    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); addToCart($('[data-atc]', form)); });

    /* All other "add to cart" buttons on the page use this buy box's selection */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-action="add-to-cart"]');
      if (btn && !btn.closest('[data-product-form]')) {
        var own = btn.closest('[data-product-section]');
        if (own && own !== section) return;
        e.preventDefault();
        addToCart(btn);
      }
    });

    /* Sticky ATC: show once the main button has scrolled above the viewport */
    var mainBtn = $('[data-main-atc]', section);
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      var hideNear = $$('[data-hide-sticky]');
      var mainGone = false, hideVisible = false;
      var update = function () {
        var show = mainGone && !hideVisible;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        document.body.classList.toggle('has-sticky-atc', show || mainGone);
      };
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { mainGone = !en.isIntersecting && en.boundingClientRect.top < 0; });
        update();
      }).observe(mainBtn);
      if (hideNear.length) {
        var vis = new Map();
        var io2 = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { vis.set(en.target, en.isIntersecting); });
          hideVisible = Array.from(vis.values()).some(Boolean);
          update();
        }, { threshold: 0.4 });
        hideNear.forEach(function (n) { io2.observe(n); });
      }
    }

    syncVariantToOffer();
    render();
  }
  $$('[data-product-section]').forEach(BuyBox);

  /* ------------------------------------------ looping card carousels */
  function Carousel(root) {
    var track = $('[data-carousel-track]', root);
    var slides = $$('[data-carousel-slide]', root);
    var dots = $$('[data-carousel-dots] button', root);
    if (!track || !slides.length) return;
    function stride() { return slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : track.clientWidth; }
    function maxScroll() { return track.scrollWidth - track.clientWidth; }
    function index() { return Math.min(slides.length - 1, Math.round(track.scrollLeft / stride())); }
    function atEnd() { return track.scrollLeft >= maxScroll() - 4; }
    function go(i) { track.scrollTo({ left: Math.max(0, Math.min(maxScroll(), slides[i].offsetLeft - slides[0].offsetLeft)), behavior: 'smooth' }); }
    function sync() { var i = atEnd() ? slides.length - 1 : index(); dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); }); }
    var p = $('[data-carousel-prev]', root), n = $('[data-carousel-next]', root);
    if (n) n.addEventListener('click', function () { if (atEnd()) go(0); else go(Math.min(slides.length - 1, index() + 1)); });
    if (p) p.addEventListener('click', function () { if (track.scrollLeft <= 4) go(slides.length - 1); else go(Math.max(0, index() - 1)); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
    var raf; track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive: true });
    sync();
  }
  $$('[data-carousel]').forEach(Carousel);

  /* ------------------------------------- theme editor: preview the cart */
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-cart-drawer]')) Cart.open();
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-cart-drawer]')) Cart.close();
  });
  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-gallery]', e.target).forEach(Gallery);
    $$('[data-product-section]', e.target).forEach(BuyBox);
    $$('[data-carousel]', e.target).forEach(Carousel);
  });

  /* ------------------------------------------------- scroll-to-buy CTAs */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-action="scroll-to-buy"]');
    if (!b) return;
    var target = $('[data-buy-anchor]');
    if (!target) return;
    e.preventDefault();
    var y = target.getBoundingClientRect().top + window.pageYOffset - 90;
    window.scrollTo({ top: y, behavior: 'smooth' });
  });
})();
